import React, { useEffect, useRef } from 'react';
import './martexecteam.scss';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { ReactComponent as TeamIcon } from '../../assets/team_icon.svg';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import TeamBox from '../../components/TeamBox/TeamBox';
import Spinner from '../../components/Spinner/Spinner';
import base from '../../apis';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';

const MartExecTeam = () => {
  const navigate = useNavigate();
  const [teamName, setTeamName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchParam, setSearchParam] = useState('');
  const TEAMS = useRef([]);

  const teamsHeader = data.length === 0 ? 'Teams created will appear here' : 'Teams';

  const fetchTeamNames = async () => {
    setIsLoading(true);
    try {
      const { data: responseData } = await base.get('operations/marketing_teams/');
      setData(responseData);

      TEAMS.current = responseData;
      if (responseData.length === 0) {
        toast.warn('No teams found');
      }
    } catch (error) {
      //TODO
      toast.error('Error loading teams');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddNewTeam = async () => {
    if (teamName === '') {
      toast.warn('Enter a Team Name', { toastId: 'nonameerror' });
      return;
    }
    setIsLoading(true);
    try {
      await base.post('/operations/marketing_teams/', {
        name: teamName,
      });
      toast.success('Team added successfully');
      setTeamName('');
      fetchTeamNames();
    } catch (error) {
      toast.error('Adding team failed');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamNames();
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    if (searchParam === '') {
      setData(TEAMS.current);
      return;
    }
    const filtered = TEAMS.current.filter((team) => team.name.toLowerCase().includes(searchParam));
    setData(filtered);
  };

  const [teamToDelete, setTeamToDelete] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const handleDeleteConfirmation = (team) => {
    setTeamToDelete(team);
    setConfirmModal(true);
  };

  const onCancel = () => {
    setConfirmModal(false);
    setTeamToDelete(null);
  };

  const onConfirm = async () => {
    setIsLoading(true);
    try {
      await base.delete(`operations/marketing_teams/${teamToDelete.id}`);
      toast.success('Team deleted successfully');
      setConfirmModal(false);
      fetchTeamNames();
    } catch (error) {
      toast.error('Deleting team failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Spinner />}
      <ConfirmationModal
        text={`Are you sure you want to delete ${teamToDelete?.name}?`}
        open={confirmModal}
        style={{ minWidth: '40vw' }}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
      <div className="mark_exec_team">
        <div className="form">
          <div className="left_side">
            <p className="title">{teamsHeader}</p>
          </div>
          <form className="mart_exec_form" onSubmit={onSearch}>
            <Input
              placeholder="By Teams's name"
              type="search"
              value={searchParam}
              onChange={(e) => setSearchParam(e.target.value)}
            />
            <Button
              style={{
                marginTop: '10px',
                height: '45px',
                width: 'fit-content',
                padding: '10px 30px',
                color: 'white',
                fontSize: '16px',
                backgroundColor: 'var(--primary-color)',
              }}
              type="submit"
              text="Filter"
            />
          </form>
        </div>

        <div className="teams">
          <div className="add_team_card">
            <p className="add_team">Add New Team</p>
            <TeamIcon className="teamIcon" />
            <Input
              onChange={(e) => {
                const value = e.target.value;
                setTeamName(value);
              }}
              value={teamName}
              placeholder="Team Name"
              fullStyles={{
                width: '70%',
                padding: '0px',
              }}
              style={{
                margin: '0px',
                fontSize: '16px',
                padding: '0px 5px',
                height: '40px',
              }}
            />
            <Button
              style={{
                width: '70%',
                margin: '0px',
                fontSize: '18px',
                padding: '10px',
                color: '#ffffff',
                display: 'block',
                background: 'var(--primary-color)',
                border: '#1378A5',
              }}
              text="Add"
              onClick={handleAddNewTeam}
            />
          </div>
          {data &&
            data.map((team) => (
              <TeamBox
                key={team.id}
                buttonText="View"
                teamName={team.name}
                numOfMembers={team.members_count}
                onClick={(color) => navigate(`${team.id}`, { state: { color } })}
                deletable={true}
                onDelete={() => handleDeleteConfirmation(team)}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default MartExecTeam;
